import apiService from '../../../services/apiService';

export const formatCurrency = (value) => {
  if (!value || value === 'not_available') return null;
  const numeric = parseFloat(String(value).replace(/[$,]/g, ''));
  return isNaN(numeric) ? null : '$' + numeric.toFixed(2);
};

export const formatDate = (iso) => iso ? new Date(iso).toLocaleString() : '';
export const formatDateForInput = (iso) => iso || new Date().toISOString();

export const listProjects = () => apiService.get('/heston/projects').then(r => r.data?.projects || r.projects || []);
export const createProject = (d) => apiService.post('/heston/projects', d).then(r => r.data?.project || r.project);
export const getProject = (id) => apiService.get('/heston/projects/' + id).then(r => r.data?.project || r.project);
export const updateProject = (id, d) => apiService.put('/heston/projects/' + id, d).then(r => r.data?.project || r.project);
export const deleteProject = (id) => apiService.delete('/heston/projects/' + id);

export const listAddresses = (id) => apiService.get('/heston/projects/' + id + '/addresses').then(r => r.data?.addresses || r.addresses || []);
export const createAddress = (d) => apiService.post('/heston/addresses', d).then(r => r.data?.address || r.address);
export const getAddress = (id) => apiService.get('/heston/addresses/' + id).then(r => r.data?.address || r.address);
export const updateAddress = (id, d) => apiService.put('/heston/addresses/' + id, d).then(r => r.data?.address || r.address);
export const deleteAddress = (id) => apiService.delete('/heston/addresses/' + id);
export const rescrapeAddress = (id) => apiService.post('/heston/addresses/' + id + '/rescrape', {});
export const getAddressHistory = (id) => apiService.get('/heston/addresses/' + id + '/history').then(r => r.data?.history || r.history || []);

export const parseCSV = (c, id) => apiService.post('/heston/import/csv', { csvContent: c, projectId: id });
export const confirmImport = (d) => apiService.post('/heston/import/confirm', d);
export const exportProjectCSV = (id) => apiService.get('/heston/export/' + id).then(d => { if (d?.downloadUrl) window.open(d.downloadUrl); });

export const processCompletedCompetitorJobs = (l = 50) => apiService.post('/heston/jobs/process-completed', { limit: l });
export const readFileAsText = (f) => new Promise((rs, rj) => { const rd = new FileReader(); rd.onload = (e) => rs(e.target.result); rd.onerror = rj; rd.readAsText(f); });

export const startBatchScrape = (id, m) => apiService.post('/heston/projects/' + id + '/batch-scrape/start', { delayMinutes: m });
export const cancelBatchScrape = (id) => apiService.post('/heston/batch-scrape/' + id + '/cancel');
export const getActiveBatchScrape = (id) => apiService.get('/heston/projects/' + id + '/batch-scrape/active').then(r => r.batch || null);

export const simulatePrices = (id, t) => apiService.post('/heston/projects/' + id + '/prices/simulate', { simulationType: t });
export const resetPrices = (id) => apiService.post('/heston/projects/' + id + '/prices/reset');
export const getSimulationStatus = (id, j) => apiService.get('/heston/projects/' + id + '/prices/simulation/' + j);
export const getResetStatus = (id, j) => apiService.get('/heston/projects/' + id + '/prices/reset/' + j);

export const getFeatureVotes = (id) => apiService.get('/heston/projects/' + id + '/feature-votes').then(r => r.votes || {});
export const saveFeatureVote = (id, n, v) => apiService.put('/heston/projects/' + id + '/feature-votes', { featureNumber: n, vote: v });

export const getChatHistory = (id) => apiService.get('/heston/projects/' + id + '/chat-history').then(r => r.messages || []);
export const saveChatHistory = (id, messages) => apiService.put('/heston/projects/' + id + '/chat-history', { messages });

const hestonService = {
  listProjects, createProject, getProject, updateProject, deleteProject,
  listAddresses, createAddress, getAddress, updateAddress, deleteAddress, rescrapeAddress, getAddressHistory,
  parseCSV, confirmImport, exportProjectCSV, readFileAsText,
  processCompletedCompetitorJobs, startBatchScrape, cancelBatchScrape, getActiveBatchScrape,
  simulatePrices, resetPrices, getSimulationStatus, getResetStatus,
  getFeatureVotes, saveFeatureVote, getChatHistory, saveChatHistory,
  formatCurrency, formatDate, formatDateForInput
};

export default hestonService;
